import React from "react";
import BaseSidebarPanel from "./ConfigurationPanel/input-panels/helpers/BaseSidebarPanel";
import {useManagerContext} from "../../../sections/emails/ManagerContext";
import Select from "../../../components/input/select";
import Text from "../../../components/input/text";
import Email from "../../../components/input/email";

export const SettingsPanel = () => {

    const {
        enterprises, domains, senders, currentEnterprise, currentDomain, currentSender,
        senderName, replyTo, subject, setSenderName, setReplyTo, setSubject,
        setCurrentEnterprise, setCurrentDomain, setCurrentSender, errors, isLoading
    } = useManagerContext()


    return (
        <BaseSidebarPanel>
            <Select required
                size="md"
                isReady={!isLoading}
                label="Enterprise"
                name="id_enterprise"
                options={enterprises || []}
                value={currentEnterprise}
                error={errors && errors['origin.id_enterprise']}
                placeholder="Choose an enterprise"
                onChange={e => setCurrentEnterprise(e?.value)}
            />

            {domains?.length > 0 &&
                <Select
                    required
                    isClearable
                    size="md"
                    label="Domain"
                    name="id_domain"
                    options={domains}
                    isReady={!isLoading}
                    value={currentDomain}
                    error={errors && errors['origin.id_domain']}
                    placeholder="Choose a domain"
                    onChange={e => setCurrentDomain(e?.value)}
                />
            }

            {senders?.length > 0
                ? <Select
                    required
                    size="md"
                    label="Sender"
                    name="id_sender"
                    options={senders}
                    isReady={!isLoading}
                    value={currentSender}
                    error={errors && errors['origin.id_sender']}
                    placeholder="Choose a sender"
                    onChange={e => setCurrentSender(e?.value)}
                />
                : <Text required
                    size="md"
                    name="sender_name"
                    label="Sender name"
                    isReady={!isLoading}
                    error={errors && errors['origin.sender_name']}
                    value={senderName}
                    placeholder="Type sender name..."
                    onBlur={ev => setSenderName(ev.target.value)}
                />

            }

            <Email required
                size="md"
                name="reply_to"
                label="Reply to"
                isReady={!isLoading}
                error={errors && errors['origin.reply_to']}
                value={replyTo}
                placeholder="Where you want to receive a reply to..."
                onBlur={ev => setReplyTo(ev.target.value)}
            />

            <Text required
                size="md"
                name="subject"
                label="Subject"
                isReady={!isLoading}
                error={errors && errors['content.subject']}
                value={subject}
                placeholder="Type the email subject..."
                onBlur={ev => setSubject(ev.target.value)}
            />

        </BaseSidebarPanel>
    )
}